<template>
  <div>
    <ServerError v-if="ServerError" />
    <PageLoader v-bind:storage="appLoading" />

    <v-layout wrap justify-center>
      <v-flex xs12>
        <SubCategorySlider />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center px-2>
      <v-flex xs12>
        <ProductDetails
          v-bind:productData="productData"
          v-bind:productPhotos="productPhotos"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start px-2 pt-6>
      <v-flex xs12 xl12>
        <ProductsSlider
          v-cloak
          v-bind:name="'BEST SELLING PRODUCTS'"
          v-bind:products="bestSellers"
        />
      </v-flex>
      <v-flex xs12 xl12 pt-4>
        <ProductsSlider
          v-cloak
          v-bind:name="'SIMILAR PRODUCTS'"
          v-bind:products="similarProducts"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import SubCategorySlider from "./../Products/subCategorySlider";
import ProductDetails from "./../Products/productDetails";
import ProductsSlider from "./../Products/productsSlider";
export default {
  props: ["productname", "id"],
  components: {
    SubCategorySlider,
    ProductDetails,
    ProductsSlider,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      productPhotos: [],
      similarProducts: {},
      bestSellers: {},
    };
  },
  mounted() {
    this.getData();
    this.getSimilar();
    this.getBestSeller();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productData = response.data.data;
          this.productPhotos = this.productData.photos;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSimilar() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/similar",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          productid: this.$route.params.id,
          count:10
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.similarProducts = response.data.data;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getBestSeller() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/bestseller",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
           count:10
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.bestSellers = response.data.data;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>